import { provide, inject, type InjectionKey } from 'vue'

export type ShokurekishoExampleSentence = {
  name?: string
  title?: string
  sentences?: string
  description?: string
  type?: string
}

export type ShokurekishoExampleSentences = {
  summary?: ShokurekishoExampleSentence[]
  prMessage?: ShokurekishoExampleSentence[]
}

export type ShokurekishoSkillItem = {
  skillname: string
  years: number | ''
  description: string
  uuid: string
}

export type ShokurekishoProjectItem = {
  projectTitle: string
  startYear: number | ''
  startMonth: number | ''
  endYear: number | ''
  endMonth: number | ''
  contentsOfProject: string
  envAndScale: string
  position: string
  uuid: string
  /** Career の会社詳細 */
  businessArea?: string
  capitalStock?: string
  numberOfEmployees?: string
  /** Skillsheet */
  dev?: string
  numberOfTeam?: string
  phase1?: boolean
  phase2?: boolean
  phase3?: boolean
  phase4?: boolean
  phase5?: boolean
  phase6?: boolean
}

export type ShokurekishoImageItem = {
  title: string
  tools: string
  description: string
  mainImage: string | null
  subImage1: string | null
  subImage2: string | null
  subImage3: string | null
  subImage4: string | null
  subImage5: string | null
  uuid: string
}

export type ShokurekishoJobHistoryItem = {
  companyName: string
  startYear: number | ''
  startMonth: number | ''
  endYear: number | ''
  endMonth: number | ''
  isContinuing: boolean
  capitalStock: string
  numberOfEmployees: string
  businessArea: string
  projects: ShokurekishoProjectItem[]
  uuid: string
  /** Career 書式。標準 Edit では空 */
  hopeJobcategory?: string
  totalYear?: number | ''
  totalMonth?: number | ''
}

export type ShokurekishoFormatData = {
  createDate: Date | null
  writeDate?: string
  occupation: string
  jobSummary: string
  experienceAndKnowledge: string
  skillsToUse: ShokurekishoSkillItem[]
  jobHistories: ShokurekishoJobHistoryItem[]
  licenseHistories: { description?: string; uuid?: string }[]
  prMessage: string
  notDisplayOmonajiseki?: boolean
  lastestEdu?: string
  lastestJob?: string
  ai_mypr_good?: string
  ai_mypr_bad?: string
  ai_mypr_hobby?: string
  ai_mypr_wanted?: string
  ai_mypr_appeal?: string
  /** WithImage。標準 Edit / Career では空配列 */
  imageItems: ShokurekishoImageItem[]
  /** Skillsheet。標準 Edit / Career / WithImage では空文字 */
  skills: string
  intelligence: string
  otherskills: string
} & Record<string, unknown>

const SHOKUREKISHO_FORMAT_DATA_KEY: InjectionKey<ShokurekishoFormatData> =
  Symbol('shokurekishoFormatData')

export function createEmptyShokurekishoFormatData(): ShokurekishoFormatData {
  return {
    createDate: null,
    occupation: 'others',
    jobSummary: '',
    experienceAndKnowledge: '',
    skillsToUse: [],
    jobHistories: [],
    licenseHistories: [],
    prMessage: '',
    notDisplayOmonajiseki: false,
    lastestEdu: '',
    lastestJob: '',
    ai_mypr_good: '',
    ai_mypr_bad: '',
    ai_mypr_hobby: '',
    ai_mypr_wanted: '',
    ai_mypr_appeal: '',
    imageItems: [],
    skills: '',
    intelligence: '',
    otherskills: ''
  }
}

export function provideShokurekishoFormatData(
  formatData: ShokurekishoFormatData
) {
  provide(SHOKUREKISHO_FORMAT_DATA_KEY, formatData)
}

export function useShokurekishoFormatData(): ShokurekishoFormatData {
  const formatData = inject(SHOKUREKISHO_FORMAT_DATA_KEY)
  if (!formatData) {
    throw new Error(
      'useShokurekishoFormatData() must be used under ShokurekishoEdit'
    )
  }
  return formatData
}

export function toExampleDialogItems(
  items: ShokurekishoExampleSentence[] | undefined,
  occupation: string
): { title: string; description: string }[] {
  if (!items || !items.length) return []
  return items
    .filter((item) => !item.type || item.type === occupation)
    .map((item) => ({
      title: String(item.name || item.title || ''),
      description: String(item.sentences || item.description || '')
    }))
}
